/**
=========================================================
* EEG Signals Course Content
* EEG signal interpretation course content
=========================================================
*/

// Course components
import EEGQuestion from "./components/EEGQuestion";

// Export course configuration
export const courseConfig = {
  title: "EEG Signals",
  subtitle: "EEG signal interpretation",
  totalSteps: 4,
};

// Export function to get question component for a step
export function getQuestionComponent(step) {
  const questions = [
    {
      question: "What EEG pattern is shown in the graph above?",
      correctState: "awake",
    },
    {
      question: "Observe the EEG signal transition over 10 seconds. What pattern does this represent?",
      correctState: "goestosleep",
    },
    {
      question: "Identify the EEG pattern shown in the graph above:",
      correctState: "burstsupression",
    },
    {
      question: "Which of the following answers are correct (multiple choice):",
      correctState: "eyeblink",
      isMultipleChoice: true,
      options: [
        { value: "asleep", label: "Patient is asleep" },
        { value: "awake", label: "Patient is awake" },
        { value: "blink3", label: "Patient blinked 3 times" },
        { value: "blink2", label: "Patient blinked 2 times" },
      ],
    },
  ];

  const questionData = questions[step - 1];
  if (!questionData) return null;

  // Use key prop to force React to unmount/remount component when step changes
  // This ensures clean state and stops previous animations
  return (
    <EEGQuestion 
      key={`eeg-question-${step}`}
      question={questionData.question} 
      correctState={questionData.correctState}
      isMultipleChoice={questionData.isMultipleChoice || false}
      options={questionData.options || null}
    />
  );
}
